<template>
  <div
    :class="navClass"
    class="sm:hidden flex fixed top-0 left-0 w-full bg-white z-50 px-2.5 h-14 items-center justify-between"
  >
    <button
      class="w-1/8 flex items-center-justify-start"
      @click="goBack"
      type="button"
    >
      <Icon name="tabler:arrow-narrow-left" size="26" />
    </button>
    <div class="w-3/4 flex items-center justify-center">
      <slot name="center"></slot>
    </div>
    <div class="w-1/8">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";

const router = useRouter();

const goBack = () => {
  router.back();
};

withDefaults(
  defineProps<{
    navClass?: string;
  }>(),
  {
    navClass: "border-b border-b-gray-100",
  },
);
</script>
